import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Navigation, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../styles.scss';
import ProjectItem from '../project_item_v1';

Project.propTypes = {
    data: PropTypes.array,
    className: PropTypes.string,
};

function Project(props) {
    const { data } = props;

    const [dataTitle] = useState(
        {
            title: 'Nuestras',
            title_2: ' Soluciones'
        }
    )

    return (
        <section className={`tf-section p-4`}>
            <div className="overlay" style={{ background: 'rgb(14 3 39 / 50%)' }} />

            <div className="container w_1690">
                <div className="row">
                    <div className="col-md-12">
                        <div className="tf-title" data-aos="fade-up" data-aos-duration="800">
                            <h2 className="title">
                                {dataTitle.title} <br className="show-destop" />
                                {dataTitle.title_2}
                            </h2>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="container_inner">
                            <div className="slider-2 navigation_project">
                                <Swiper
                                    modules={[Navigation, Autoplay]}
                                    spaceBetween={30}
                                    slidesPerView={1}
                                    navigation
                                    autoplay={{ delay: 5000, disableOnInteraction: false }}
                                    loop={true}
                                    breakpoints={{
                                        0: {
                                            slidesPerView: 1,
                                        },
                                        750: {
                                            slidesPerView: 2,
                                        },
                                        991: {
                                            slidesPerView: 3,
                                        },
                                        1280: {
                                            slidesPerView: 4,
                                        },
                                    }}
                                >
                                    {
                                        data.map(item => (
                                            <SwiperSlide key={item.id}>
                                                <ProjectItem item={item} />
                                            </SwiperSlide>
                                        ))
                                    }
                                </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Project;